import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataServiceBase } from '../../../core/service/base/data.service.base';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { map, Observable } from 'rxjs';
import { InvoiceRowFormDefaultsModel } from '../../model/invoice-row-edit';

@Injectable()
export class InvoiceRowService extends DataServiceBase {
  constructor(client: HttpClient, notification: MessageService, progressBar: ProgressBarService, @Inject(APP_CONFIG) config: IAppConfig) {
    super(client, notification, progressBar, config, 'invoice-row');
  }

  getDefaultsViewModel(companyId: string): Observable<InvoiceRowFormDefaultsModel> {
    return this.client
      .get<InvoiceRowFormDefaultsModel>(`${this.endpoint}/defaults/${companyId}`)
      .pipe(map(res => new InvoiceRowFormDefaultsModel(res)));
  }
}
